const Pagination = ({ onBack, onNext, currentPage, numberOfPages, onClickPage }) => {
    return (
        <div className="d-flex col-12 justify-content-between mt-5 mb-5 mb-md-0">
            <button
                className="btn btn-primary btn-xs"
                disabled={currentPage <= 1}
                style={{ border: 'none !important' }}
                onClick={() => {
                    if (currentPage > 1) onBack?.(currentPage - 1);
                }}
            >
                <i className="fa fa-angle-double-left" aria-hidden="true"></i>
                Anterior
            </button>
            <span className="custom-horizontal-scrollbar scrollbar-primary" style={{ maxWidth: '100%', display: 'flex', overflowX: 'auto' }}>
                {Array.from(Array(numberOfPages).keys()).map((number, i) => (
                    <div
                        key={i}
                        className={`${currentPage === (i + 1) ? "current bg-primary text-white" : ""}`}
                        onClick={() => onClickPage(1 + number)}
                        style={{
                            marginRight: '10px',
                            padding: '10px 15px',
                            borderRadius: '10px',
                            cursor: 'pointer'
                        }}
                    >
                        {1 + number}
                    </div>
                ))}
            </span>
            <button
                className="btn btn-primary btn-xs"
                disabled={currentPage >= numberOfPages}
                onClick={() => {
                    if (currentPage < numberOfPages) onNext?.(currentPage + 1);
                }}
            >
                Siguiente
                <i className="fa fa-angle-double-right" aria-hidden="true"></i>
            </button>
        </div>
    )
}


export default Pagination;